import React from 'react';
import { Seo } from 'components';
import Company from 'components/Company/Company';

export default ({ location }) => (
  <>
    <Seo
      title="О компании | Nimax"
      description="Nimax — диджитал-агентство полного цикла. Создаём комплексный маркетинг и проектируем бренды как единую систему для технологичных компаний."
      url={`https://nimax.ru${location.pathname}`}
    />
    <Company />
  </>
);
